// @ts-nocheck
import * as util from '@/util';

function getLocale(/*editorAPI, appData, token*/) {
  return util.editorModel.languageCode;
}

export { getLocale };
